import { render, staticRenderFns } from "./FormCarteira.vue?vue&type=template&id=53d7e314&scoped=true"
import script from "./FormCarteira.vue?vue&type=script&lang=js"
export * from "./FormCarteira.vue?vue&type=script&lang=js"
import style0 from "./FormCarteira.vue?vue&type=style&index=0&id=53d7e314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d7e314",
  null
  
)

export default component.exports